.EditorWorkingArea {
  .EditorContent {
    min-height: 100%;
    max-width: 900px;
    margin: 0 auto 0;
    padding: 88px 72px 144px;

    > div {
      outline: none;
    }

    pre {
      code {
        color: inherit;
        padding: 0;
        background: none;
        font-size: 1rem;
      }
    }

    ul {
      margin: 16px 0;

      li {
        display: flex;
        gap: 16px;

        p {
          text-indent: 0;
        }

        &::before {
          content: '•';
          font-size: 2rem;
        }
      }
    }

    > p,
    blockquote {
      transition: opacity 0.2s ease;
    }
  }

  p {
    & a {
      text-decoration: underline;
    }
  }

  > div {
    outline: none;
  }

  sup {
    font-weight: 600;
  }

  blockquote {
    position: relative;
    margin: 0;
    padding: 16px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 4px;
      left: -4px;
    }
  }
}

.EditorWorkingAreaNoIndent .ProseMirror {
  text-indent: none;
}

.EditorWorkingAreaHasFocus .ProseMirror > p,
.EditorWorkingAreaHasFocus .ProseMirror > blockquote {
  transition: opacity 0.2s ease;
  opacity: 0.1;
}

.EditorWorkingAreaHasFocus .ProseMirror > p.has-focus,
.EditorWorkingAreaHasFocus .ProseMirror blockquote.has-focus {
  opacity: 1;
}
